import { Component, OnInit } from "@angular/core";
import { ContentHeader } from "../../../layout/components/content-header/content-header.component";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseListDirective } from "../../../util/directives/base-list.directive";
import { ModalService } from "../../../util/service/modal.service";
import Swal from "sweetalert2";
import { colors } from "../../../colors.const";
import { EnumDropdownOption, EnumService } from "../../../util/service/enum.service";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { OfficeListItemDto } from "app/api/models";
import { OfficeService } from "app/api/services";
import { EnumDisplayService } from "../../../util/service/enum-display.service";
import { AuthService } from "../../../util/service/auth.service";
import { UserRole } from "../../../server/enums/user-role.enum";
import { CaslAction } from "../../../server/enums/casl-action.enum";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-office-list",
    templateUrl: "./office-list.component.html",
    styleUrl: "./office-list.component.scss",
    standalone: false
})
export class OfficeListComponent extends BaseListDirective<OfficeListItemDto> implements OnInit {
  override modalType = EntityTyp.Office;
  protected readonly UserRole = UserRole;

  public contentHeader: ContentHeader;
  typeOptions!: EnumDropdownOption[];

  constructor(
    protected override route: ActivatedRoute,
    protected override router: Router,
    private officeService: OfficeService,
    protected override modalService: ModalService,
    public enumService: EnumService,
    protected override fb: FormBuilder,
    public enumDisplayService: EnumDisplayService,
    public authService: AuthService,
    private toastrService: ToastrService
  ) {
    super(fb, route, router, modalService);
  }

  ngOnInit(): void {
    this.typeOptions = this.enumService.officeTypeDropdownOptions;
    this.contentHeader = {
      headerTitle: "Standorte",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Startseite",
            isLink: true,
            link: "/",
            translate: "MENU.HOME",
          },
          {
            name: "Standorte",
            isLink: false,
            translate: "MENU.OFFICES",
          },
        ],
      },
    };

    this.initFilter({
      name: [null],
      type: [null],
    });
  }

  reload() {
    this.officeService.officeControllerFindAll(this.filter.value).subscribe({
      next: (page) => {
        this.page = page;
        this.syncPageNumber();
      },
    });
  }

  async openModal(id?: number) {
    await this.modalService.openEntityModal(EntityTyp.Office, id);
    this.reload();
  }

  async delete(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diesen Standort wirklich löschen?",
      icon: "error",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.danger,
      confirmButtonText: "Löschen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.officeService.officeControllerDelete({ id }).subscribe((res) => {
        this.reload();
      });
    }
  }

  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;

  async restore(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diesen Standort wirklich wiederherstellen?",
      icon: "question",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.info,
      confirmButtonText: "Wiederherstellen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.officeService.officeControllerRestore({ id }).subscribe((res) => {
        this.toastrService.success("Erfolgreich wiederhergestellt", "Erfolgreich wiederhergestellt");
        this.reload();
      });
    }
  }
}
